import { useFormContext } from 'react-hook-form'
import { Input, RescheduleAppointmentSchema } from './schema'
import { AvailableSlots as AvailableSlotsComponent } from '$components'
import { Text } from '$components'

export function AvailableSlots() {
  const { watch, setValue } = useFormContext<RescheduleAppointmentSchema>()
  const services = watch(Input.Services)
  const date = watch(Input.Date)
  const duration = watch(Input.Duration)
  const selectedSlot = watch(Input.Slot)

  if (!services || services.length === 0) {
    return (
      <div className="p-stack-section bg-surface-muted rounded-surface flex items-center justify-center">
        <Text
          type="s"
          weight="light"
        >
          Select services to see available slots
        </Text>
      </div>
    )
  }

  if (!duration || !date) {
    return null
  }

  return (
    <AvailableSlotsComponent
      duration={duration}
      date={date}
      enabled={!!services && !!date && services.length > 0}
      selectedSlotId={selectedSlot?.id}
      onSlotSelect={(slot) => setValue(Input.Slot, slot)}
      emptyStateMessage="No slots available for this date"
    />
  )
}
